export default __webpack_public_path__ + "sync-pending-icon.asset.77ececbcc91e0166ce5e817b7e8dee14.svg";